import DIWBasketAction from '@/utilities/diw.basket.action';
import TKBasketButton from '@tk/components/tk.basket.button';
import DIWPrice from '@/components/diw.price';
import DIWBasketAction from '@/utilities/diw.basket.action';

export default class DIWBasketButton extends TKBasketButton {
    articleWrapper?: HTMLElement;

    constructor() {
        super();

        this.basketAction = new DIWBasketAction(this);
        this.articleWrapper = this.closest('[data-article-wrapper]') || undefined;
    }

    increase() {
        if (!this.counter || !this.increaser) return;
        const { step, max, value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
        this.syncPriceQuantity();
    }

    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step, min, value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
        this.syncPriceQuantity();
    }

    change(event: KeyboardEvent) {
        DIWBasketAction.quantityChanger(event);
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.button?.click();
            this.syncPriceQuantity();
        }, 500);
    }

    syncPriceQuantity() {
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            if (!this.counter) return;
            const priceElement = this.articleWrapper?.querySelector<DIWPrice>('[data-tk-dynamic-price]');
            priceElement?.setAttribute('data-quantity', this.counter.value);
        }, 500);
    }
}
